import { useSelector } from 'react-redux'
import { useEditingStateWithCtx } from '@/atoms'
import { selectDepotsListStructure } from '@/features/domain/lists'

import { useSearchList } from './useSearchList'

export function useFilter() {
  const structure = useSelector(selectDepotsListStructure)
  const { editing } = useEditingStateWithCtx('depot')
  const { query, setQuery } = useSearchList()

  return {
    query,
    editing,
    setQuery,
    noEntries: structure.totalItems === 0,
  }
}
